import Lottie from 'lottie-react';

import dog12WithPhoneAndProvider from '../jsons/Dog_12_with_phone_and_provider.json';

const Dog12WithPhoneAndProvider = props => {
  return <Lottie animationData={dog12WithPhoneAndProvider} {...props} />;
};

export default Dog12WithPhoneAndProvider;
